import { createFormContext } from '@mantine/form';

import type { AeropayBankName, PaymentType } from '~/common/enums/payments.enum';

export type FormValues = {
  mode?: 'withdrawal' | 'refund';
  paymentType: PaymentType;
  /** Needed for Aeropay */
  bankAccountId?: string;
  bankName?: AeropayBankName;
  bankAccountName?: string;
  withdrawalAmount?: number;
  completedWithdrawalAmount?: number;
  cardOption?: string;
};

const [WithdrawalFormProvider, useWithdrawalFormContext, useWithdrawalForm] =
  createFormContext<FormValues>();

export { useWithdrawalForm, useWithdrawalFormContext, WithdrawalFormProvider };
